/**
 * Multi-tenant theme definitions
 * Each tenantId maps to a set of CSS variables applied at the root.
 */

export const themes = {
  // Default Starfuel dark/gold brand
  starfuel: {
    '--color-primary': '#e6b300',
    '--color-primary-dark': '#b38a00',
    '--color-primary-light': '#ffd54d',
    '--color-bg': '#0a0a0a',
    '--color-surface': '#111111',
    '--color-surface-2': '#1a1a1a',
    '--color-text': '#f5f5f5',
    '--color-text-muted': '#9a9a9a',
    '--color-border': '#2e2e2e',
    '--color-success': '#22c55e',
    '--color-error': '#ef4444',
    '--color-warning': '#f59e0b',
    '--font-display': '"Bebas Neue", Impact, sans-serif',
    '--font-body': '"DM Sans", system-ui, sans-serif',
    '--logo-text': 'STARFUEL',
    '--brand-tagline': 'CarFleet & Chauffeur Service',
  },

  // B.O.B. Collective — deep green/black with cream accents
  bob_collective: {
    '--color-primary': '#2d6a4f',
    '--color-primary-dark': '#1b4332',
    '--color-primary-light': '#52b788',
    '--color-bg': '#0c1510',
    '--color-surface': '#111f17',
    '--color-surface-2': '#1a2e22',
    '--color-text': '#f0ead2',
    '--color-text-muted': '#8d9e8e',
    '--color-border': '#2d4a35',
    '--color-success': '#40916c',
    '--color-error': '#c0392b',
    '--color-warning': '#e67e22',
    '--font-display': '"Bebas Neue", Impact, sans-serif',
    '--font-body': '"DM Sans", system-ui, sans-serif',
    '--logo-text': 'B.O.B. COLLECTIVE',
    '--brand-tagline': 'Black-Owned Business Fleet Network',
  },
};

/**
 * Apply theme CSS variables to the document root
 */
export function applyTheme(tenantId) {
  const theme = themes[tenantId] || themes.starfuel;
  const root = document.documentElement;
  Object.entries(theme).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}

export function getTheme(tenantId) {
  return themes[tenantId] || themes.starfuel;
}
